import React, { ReactNode, useState } from "react";

import { MinusIcon } from "@/components/icons/MinusIcon";
import { PlusIcon } from "@/components/icons/PlusIcon";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { cn } from "@/utils/general";
import { segmentEvent } from "@/utils/segmentfunctions";

import styles from "./AccordionNavigation.module.scss";

interface AccordionProps {
  title: string;
  open?: boolean;
  children?: ReactNode;
}

const Accordion: React.FC<AccordionProps> = ({ title, open = false, children }) => {
  const [isOpen, setIsOpen] = useState(open);

  const toggleAccordion = () => {
    if (!isOpen) {
      segmentEvent("Navigation Expanded", {
        module_location: "navigation",
        text: title,
      });
    }
    setIsOpen(!isOpen);
  };

  return (
    <div
      className={cn(
        styles.accordionBox,
        `accordion-box-${title?.replace(/ /g, "-").toLowerCase()}`
      )}
    >
      <button
        className={cn(styles.accordionButton, {
          [styles.active]: isOpen,
        })}
        onClick={toggleAccordion}
        aria-expanded={isOpen}
        aria-controls={`accordion-content-${title?.replace(/ /g, "-").toLowerCase()}`}
        id={`accordion-button-${title?.replace(/ /g, "-").toLowerCase()}`}
        type="button"
        aria-label={title}
      >
        <div className="flex justify-between items-center">
          <div>
            <TextElementNova text={title} className="Body-30-Dia-Normal text-nova-base-black" />
          </div>

          <div>
            {isOpen ? (
              <MinusIcon className="text-nova-base-solid-40" />
            ) : (
              <PlusIcon className="text-nova-base-solid-20" />
            )}
          </div>
        </div>
      </button>

      {isOpen && (
        <div
          className="mb-4"
          id={`accordion-content-${title?.replace(/ /g, "-").toLowerCase()}`}
          role="region"
          aria-labelledby={`accordion-button-${title?.replace(/ /g, "-").toLowerCase()}`}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default Accordion;
